import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  resultTable: {
    margin: "10px 25px 25px 25px !important",
    width: "100%",
    borderCollapse: "collapse",
  },
  thHeader: {
    backgroundColor: theme.palette.header,
    color: theme.palette.amano.base.main,
    fontWeight: "bold",
  },
  resultHeader: {
    padding: "12px 8px",
  },
  sortableHeader: {
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
  sortLabel: {
    color: `${theme.palette.amano.base.main} !important`,
    "& .MuiTableSortLabel-icon": {
      color: `${theme.palette.amano.base.main} !important`,
    },
  },
}));
